if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const prevArrowHTML =
    `<button class="slick-arrow slick-prev">
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" stroke-width="1" stroke="currentColor"><rect width="48" height="48" x="1" y="1" shape-rendering="crispEdges" /><path d="M 32 12 L 18 25 L 32 38" /></svg>
        <span>Prev</span>
    </button>`;
const nextArrowtHTML =
    `<button class="slick-arrow slick-next">
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" stroke-width="1" stroke="currentColor"><rect width="48" height="48" x="1" y="1" shape-rendering="crispEdges" /><path d="M 18 12 L 32 25 L 18 38" /></svg>
        <span>Next</span>
    </button>`;

const slickOptions = {
    accessibility: false,
    prevArrow: prevArrowHTML,
    nextArrow: nextArrowtHTML
};

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    // ADD SVG TO DEFAULT BTNs
    const btnSVG = `<svg width="50" height="50" viewBox="0 0 50 50" fill="none" stroke-width="1"><rect width="48" height="48" x="1" y="1" shape-rendering="crispEdges" /><path d="M 18 12 L 32 25 L 18 38" /></svg>`;
    document.querySelectorAll('.btn:not(.btn-alt)').forEach( btn => btn.innerHTML = `${btnSVG}<span>${btn.textContent}</span>` );


    // WRAP MODULE TABLES
    document.querySelectorAll('.tableModule table').forEach(table => {
        const tableWrapper = document.createElement('div');
        tableWrapper.classList.add('tableModule_wrap');
        table.parentNode.insertBefore(tableWrapper, table);
        tableWrapper.appendChild(table);
    });

    $('.sym-slides').slick( slickOptions );

    // Dining slider Nav
    const $diningNav = $('.diningModule_carouselList');
    const $targetSlider = $( $diningNav.slick('slickGetOption', 'asNavFor') );

    $diningNav.on('click', '.diningModule_carouselItem', function () {
        const slideNum = $(this).attr('data-slick-target') - 1;
        $targetSlider.slick( 'slickGoTo', slideNum );
    });

    //form funcionality
    // const checkselect = [];
    // document.querySelectorAll(".js-checkbox-rf").forEach(check => {
    //         const textarea = document.querySelector(".js-textarea-rf textarea");
        
    //     check.addEventListener('change', () => {
    //         if (check.checked) {
    //             checkselect.push(check.value.replace(/-/g," "))
    //         } else {
    //             const index = checkselect.indexOf(check.value.replace(/-/g," "));
    //             if (index > -1) {
    //                 checkselect.splice(index, 1);
    //             }     
    //         }
    //         textarea.value = checkselect;
    //     });
    // });

    let checkselect = [];

    const textarea = document.querySelector(".js-textarea-rf textarea");
    textarea.setAttribute( "readonly", "true" );
    textarea.style.opacity = "0";

    document.querySelectorAll('.js-item-quantity').forEach(select => {
        select.addEventListener('change', function(){
            let label = this.getAttribute('name').replace(/-/g," ");
            let addedValue = this.getAttribute('name').replace(/-/g," ")+ ':' + this.value + ' ';

            let temp_checkselect = null;
            let updated = false;

            let _val = this.value;

            checkselect.forEach( (value, index) => {
                if( value.indexOf( label ) != "-1" && _val != 0 ){
                    checkselect[ index ] = addedValue;
                    updated = true;
                }else if( _val == 0 ){
                    checkselect.splice( index, 1 );
                    updated = true;
                }
            } )

            if( !updated && _val != 0 ){
                checkselect.push( addedValue )
            }

            console.log( checkselect );

            textarea.value = checkselect.toString();
        })
    });
    
    //For Menu Tabs
    document.querySelectorAll('.restaurant-form__tabs li').forEach((btn, i) => {
        btn.addEventListener('click', _ => {
                document.querySelectorAll('.restaurant-form__tabs li').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');

                document.querySelectorAll('.restaurant-form__unitmenu').forEach(room => {
                        room.classList.remove('active');
                        if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
                                room.classList.add('active');
                        }
                });
        });

        if (i === 0) btn.click();
    });

    const select_menu = document.querySelector('#select-menu');
    if (select_menu != null) {
        
        select_menu.addEventListener('change', _ => {
            document.querySelectorAll('.restaurant-form__unitmenu').forEach(room => {
                room.classList.remove('active');
                if ( select_menu.value === 'all' || select_menu.value === room.dataset.tag ) {
                        room.classList.add('active');
                }
            });
        });
    }

    let menu_form = document.querySelector( "#form_id-2153" )
    let message_manus = document.querySelector( ".js-textarea-rf textarea" )

    menu_form.addEventListener( "submit", ( evt ) => {
        
        if( message_manus.value == "" ){
            evt.preventDefault();
            evt.stopPropagation();

            setTimeout( () => {
                if (document.querySelector( "#menu_items-error" )) {
                    document.querySelector( "#menu_items-error" ).innerHTML = "Please select a Menu item";
                } else {
                    document.querySelector(".js-textarea-rf").insertAdjacentHTML("beforeend", '<label id="menu_items-error" class="error" for="menu_items">Please select a Menu item</label>')
                }
            }, 10 )

            return false;
        }

    } )

    document.querySelector( "[name=menu_items]" ).style.display = "none"

})();